// extracted by mini-css-extract-plugin
module.exports =  {"codePanel":"xhvM05eX8eZJbdG6nyvJ"};